<template>
	<VPopover v-if="tooltip" position="top">
		<template #content>
			{{ tooltip }}
		</template>
		<span
			class="badge-icon"
			:class="{ 'badge-icon--active': active }"
		>
			<slot/>
		</span>
	</VPopover>

	<span
		v-else
		class="badge-icon"
		:class="{ 'badge-icon--active': active }"
	>
		<slot/>
	</span>
</template>

<style lang="scss" src="./VBadgeIcon.scss"/>

<script lang="ts">
export default defineComponent({
	name: 'VBadgeIcon',

	props: {
		/** Активное состояние — зелёный, иначе серый */
		active: {
			type:    Boolean,
			default: false,
		},
		/** Подсказка при наведении */
		tooltip: {
			type:    String,
			default: '',
		},
	},
});
</script>
